export default "__VITE_ASSET__Cn2zX6XE__"